/* christina-lazy-sections.js — R8 (2026-08-05), P0-fix arkuszy sekcji (2026-08-05),
 *                              P1-fix stempla `data-section-id` (2026-08-06)
 *
 * PO CO TO JEST
 * Dokument kolekcji ważył 845 639 B, z czego ponad połowa to markup, którego
 * przeglądarka nie potrzebuje ani do pierwszego renderu, ani do pierwszej
 * interakcji: stopka (91 997 B), głębokie panele mega menu (45 977 B),
 * mobilna szuflada menu (17 684 B), ciało koszyka (22 696 B), panele filtrów.
 * Runda 6 schowała część z tego w `<template>` — to NIC nie dało po stronie
 * sieci, bo `<template>` i tak jedzie w dokumencie; oszczędzało wyłącznie
 * budowę DOM. Runda 8 wyjmuje te bloki z dokumentu i dociąga je
 * **Section Rendering API** (`?section_id=<id>`) dopiero przy zamiarze użycia.
 *
 * KONTRAKT Z LIQUIDEM
 * Sekcja, która ma część treści leniwą, rozgałęzia się na `section.index == nil`
 * (Shopify ustawia `index` na `nil` wyłącznie przy renderze przez Section
 * Rendering API oraz w edytorze motywu — patrz shopify.dev/docs/api/liquid/objects/section):
 *   · render normalny  → wypisuje LEKKI placeholder `[data-cclazy-slot]`
 *                        + lustro linków w `<noscript>` (SEO i brak JS),
 *   · render przez API → wypisuje CIĘŻKĄ zawartość w `[data-cclazy-part]`.
 * Dzięki temu ustawienia sekcji (`section.settings`, `section.blocks`) są te
 * same w obu ścieżkach — nie trzeba duplikować schematu ani zgadywać wartości.
 *
 * ARKUSZE SEKCJI — P0 05.08.2026 (patrz `carryAssets`)
 * Sekcja renderowana przez API wypisuje swój `<style>` POZA `[data-cclazy-part]`
 * (tak robi `christina-footer-main.liquid`: `{% render 'christina-footer-main-css' %}`
 * stoi przed opakowaniem ładunku). Wcześniej `materialize()` brał wyłącznie
 * dzieci `[data-cclazy-part]`, więc arkusz był po cichu WYRZUCANY — stopka
 * lądowała na stronie bez ani jednej własnej reguły. Skutek zmierzony na
 * produkcji: pięć gwiazdek `.cf-news-trust-stars svg` (viewBox 24x24, bez
 * atrybutów `width`/`height`, bez reguły CSS) rozlewało się do szerokości
 * kontenera — 2545x2545 px KAŻDA, czyli 12 725 px słupka i 26 458 px całej
 * stopki. Dla użytkownika: czarny kształt na cały ekran pod sekcją opinii.
 * Dlatego `materialize()` przenosi teraz razem z treścią każdy `<style>`
 * i `<link rel="stylesheet">` z pobranego dokumentu — z deduplikacją, żeby
 * arkusz obecny już w dokumencie (np. `christina-a11y-p0.css`, wypisywany
 * w OBU gałęziach) nie doklejał się po raz drugi.
 *
 * STEMPEL `data-section-id` — P1 06.08.2026 (patrz `materialize`)
 * Panele filtrów przychodzą z sekcji technicznej `christina-facets-panel`,
 * która nie zna id sekcji kolekcji, więc `facet-form` przyjeżdża
 * z `data-section-id=""`. `theme.utils.sectionId()` zwraca WARTOŚĆ atrybutu,
 * jeśli atrybut istnieje — czyli pusty string — i `facet-form.buildUrl()`
 * woła `…?section_id=` (404), a `facet-count.onFacetUpdate` wywala się na
 * `querySelector('facet-count').innerHTML` z `null`. Stąd stemplowanie id.
 * Dwie pułapki, obie zmierzone na produkcji 06.08.2026:
 *   1. stempel leciał po `src.querySelectorAll(...)`, a `src` był JUŻ PUSTY —
 *      pętla `while (src.firstChild) frag.appendChild(...)` przenosi dzieci
 *      do fragmentu ZANIM stempel się wykona. Kod był martwy. Dlatego
 *      stemplujemy `frag`, nie `src`.
 *   2. awaryjne dochodzenie id po wstawieniu (`closest('[id^="shopify-section-"]')`)
 *      działa tylko na desktopie. Na mobile `DrawerElement` motywu przy otwarciu
 *      PRZENOSI `#FacetDrawerSticky` do `document.body` (theme.js:
 *      `shouldAppendToBody && document.body.append(this)`), więc formularz
 *      w szufladzie nie ma już ŻADNEGO przodka `shopify-section-…` i awaryjna
 *      ścieżka zwraca `null`. Id musi pochodzić z `data-cclazy-sectionid`
 *      placeholdera, odczytanego zanim placeholder zniknie z drzewa.
 * Stemplujemy WYŁĄCZNIE `[data-section-id=""]`, żeby nie nadpisać własnych,
 * poprawnych id w innych leniwych blokach (koszyk, stopka, mega menu).
 *
 * WYZWALACZE (atrybut `data-cclazy-on`, lista po przecinku)
 *   intent  — pointerenter / pointerdown / focusin / keydown / click na
 *             placeholderze, na elemencie `data-cclazy-owner` i na każdym
 *             `[aria-controls="<id>"]`,
 *   view    — IntersectionObserver, rootMargin 800 px (stopka),
 *   event   — dowolne zdarzenie na `document` z `data-cclazy-event`
 *             (np. `cart:refresh`, gdy koszyk otwiera kod motywu).
 *
 * WYŚCIG Z KLIKNIĘCIEM
 * Motyw rozwiązuje `aria-controls` getterem `document.getElementById(...)`
 * w chwili kliknięcia, więc element musi istnieć ZANIM handler motywu ruszy.
 * `pointerdown` daje zwykle ~100 ms zapasu, ale to nie jest gwarancja (klawiatura,
 * czytnik ekranu, szybki tap). Dlatego kliknięcie w niezmaterializowany wyzwalacz
 * jest PRZECHWYTYWANE w fazie przechwytywania, wstrzymywane, a po wstawieniu
 * treści odtwarzane na tym samym elemencie. Użytkownik nie widzi różnicy,
 * a handler motywu nigdy nie dostaje `null`.
 *
 * CZEGO NIE CACHUJEMY (świadomie)
 * Koszyk, ceny B2B, stany magazynowe i cokolwiek zależnego od zalogowania idzie
 * ZAWSZE z sieci (`data-cclazy-cache="no"`). Cache trzyma tylko treść statyczną
 * (menu, stopka) w `sessionStorage`, pod kluczem zawierającym id motywu, język
 * i kraj (rynek) — więc przełączenie języka albo rynku nie podaje starej wersji.
 * Klucz zawiera też `?v=` TEGO pliku, więc każda jego zmiana unieważnia cache
 * sama z siebie (to dlatego P0 powyżej nie wymaga czyszczenia sesji u klientów).
 * Zasięg to jedna sesja karty; nie ma tu ani jednego `localStorage`.
 *
 * DOSTĘPNOŚĆ / bfcache
 * Placeholder nie jest elementem interaktywnym — wyzwalaczem zostaje oryginalny
 * przycisk motywu z `aria-controls`/`aria-expanded`. Po materializacji fokus
 * przechodzi na element wskazany w `data-cclazy-focus`, jeśli podano.
 * Brak nasłuchów `unload`/`beforeunload` i brak stanu w URL — powrót „wstecz"
 * z bfcache odtwarza stronę bez błędów; już zmaterializowane bloki po prostu są.
 */
(function () {
  'use strict';
  if (window.__ccLazySections) return;
  window.__ccLazySections = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var me = document.currentScript;
  var ASSET_V = (function () {
    try { return (me && me.src || '').split('?v=')[1] || '0'; } catch (e) { return '0'; }
  })();
  var SCOPE = [
    (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '0',
    (window.Shopify && window.Shopify.locale) || '',
    (window.Shopify && window.Shopify.country) || '',
    ASSET_V
  ].join('|');

  var inflight = {};        /* sectionId -> Promise<string> */
  var slots = [];           /* rejestr placeholderów */
  var seenAssets = {};      /* arkusze już przeniesione do dokumentu */

  function ck(id) { return 'cclazy:' + SCOPE + ':' + id; }

  function fetchSection(id, base, cacheable) {
    var k = id + '@' + base;
    if (inflight[k]) return inflight[k];
    var cached = null;
    if (cacheable) { try { cached = sessionStorage.getItem(ck(k)); } catch (e) {} }
    var p;
    if (cached) {
      p = Promise.resolve(cached);
    } else {
      var url = base + (base.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
      p = fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (t) {
          if (cacheable) { try { sessionStorage.setItem(ck(k), t); } catch (e) {} }
          return t;
        });
    }
    inflight[k] = p;
    return p;
  }

  /* Skrypty wstawione przez innerHTML się nie wykonują — odtwarzamy je. */
  function runScripts(root) {
    var list = root.querySelectorAll ? root.querySelectorAll('script') : [];
    for (var i = 0; i < list.length; i++) {
      var old = list[i];
      var s = document.createElement('script');
      for (var j = 0; j < old.attributes.length; j++) {
        s.setAttribute(old.attributes[j].name, old.attributes[j].value);
      }
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    }
  }

  /* Arkusze sekcji stoją POZA `[data-cclazy-part]` (Liquid wypisuje je przed
     opakowaniem ładunku), więc bez tego kroku ginęły razem z resztą dokumentu
     odpowiedzi — patrz nota „ARKUSZE SEKCJI" w nagłówku pliku.
     Deduplikacja jest DWUSTOPNIOWA:
       · `seenAssets` — żeby druga materializacja tej samej sekcji (albo dwie
         sekcje dzielące ten sam snippet CSS) nie dokleiła arkusza ponownie,
       · przegląd `link[rel~="stylesheet"]` w dokumencie — bo część arkuszy
         (`christina-a11y-p0.css`) jest wypisywana w OBU gałęziach sekcji
         i już siedzi w dokumencie; ponowne wstawienie to zbędne żądanie
         i druga kopia reguł w kaskadzie.
     `<style>` wstawiony przez `appendChild` DZIAŁA (to element, nie skrypt),
     więc nie trzeba go odtwarzać tak jak `<script>` w `runScripts`. */
  function carryAssets(doc, src, frag) {
    var list = doc.querySelectorAll('style, link[rel~="stylesheet"]');
    for (var i = 0; i < list.length; i++) {
      var node = list[i];
      if (src && src.contains && src.contains(node)) continue; /* pojedzie razem z treścią */
      var href = node.getAttribute ? node.getAttribute('href') : null;
      var key = href ? 'h:' + href : 's:' + (node.textContent || '');
      if (seenAssets[key]) continue;
      seenAssets[key] = true;
      if (href) {
        var have = document.querySelectorAll('link[rel~="stylesheet"]');
        var dup = false;
        for (var j = 0; j < have.length; j++) {
          if (have[j].getAttribute('href') === href) { dup = true; break; }
        }
        if (dup) continue;
      }
      frag.appendChild(document.importNode(node, true));
    }
  }

  function materialize(slot, html) {
    if (!slot.parentNode) return;
    var doc;
    try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { return; }
    var part = slot.getAttribute('data-cclazy-part');
    var src = part ? doc.querySelector('[data-cclazy-part="' + part + '"]') : doc.body;
    if (!src) { slot.setAttribute('data-cclazy-state', 'empty'); return; }

    /* Id sekcji czytamy ZANIM cokolwiek ruszymy w drzewie — placeholder zaraz
       zniknie, a na mobile jego przodek (szuflada filtrów) potrafi w tym samym
       czasie wylądować w `document.body`. Patrz nota „STEMPEL `data-section-id`". */
    var sid = slot.getAttribute('data-cclazy-sectionid');
    if (!sid) {
      /* Liquid nie zawsze zna id sekcji w miejscu renderu snippetu. Bierzemy
         wtedy id z opakowania `shopify-section-…`, w którym placeholder
         fizycznie stoi — a to jest dokładnie ta sekcja, którą `facet-form`
         ma przerenderować po zmianie filtra. */
      var wrap = slot.closest('[id^="shopify-section-"]');
      if (wrap) sid = wrap.id.replace('shopify-section-', '');
    }

    /* `data-cclazy-mode="self"` — wstaw TEN element, nie jego dzieci.
       Potrzebne tam, gdzie korzeń ładunku niesie klasy układu (mini-koszyk:
       `.flex.flex-col.h-full`) i musi zostać dokładnie taki, jaki był przed R8,
       bo ten sam markup wraca też z bundled section rendering. */
    var frag = document.createDocumentFragment();
    /* Arkusz sekcji IDZIE PIERWSZY — wchodzi do dokumentu razem z markupem,
       w tym samym `replaceChild`, więc treść nie pojawia się ani na klatkę
       bez swoich reguł (brak FOUC i brak skoku układu). */
    carryAssets(doc, src, frag);
    if (src.getAttribute && src.getAttribute('data-cclazy-mode') === 'self') {
      frag.appendChild(document.importNode(src, true));
    } else {
      while (src.firstChild) frag.appendChild(src.firstChild);
    }
    /* Stempel robimy na `frag` — `src` jest w tym miejscu PUSTY (dzieci
       przeniesione wyżej), więc pytanie go o cokolwiek zwracało zero węzłów.
       Tylko puste `data-section-id`, żeby nie nadpisać poprawnych id
       przynoszonych przez inne leniwe bloki. */
    if (sid) {
      var need = frag.querySelectorAll('[data-section-id=""]');
      for (var q = 0; q < need.length; q++) need[q].setAttribute('data-section-id', sid);
    }
    var focusSel = slot.getAttribute('data-cclazy-focus');
    var parent = slot.parentNode;
    /* Lustro `<noscript>` znika razem z placeholderem — jego rolę przejmuje
       teraz prawdziwy markup, więc linki nie dublują się w drzewie a11y. */
    parent.replaceChild(frag, slot);
    /* Siatka bezpieczeństwa: gdyby placeholder nie niósł `data-cclazy-sectionid`
       i nie dało się go wyliczyć wcześniej, próbujemy jeszcze raz na żywym
       drzewie. Na mobile ta ścieżka NIE zadziała dla szuflady filtrów
       (jest już poza `shopify-section-…`) — dlatego pierwszy stempel wyżej
       jest tym właściwym, a nie awaryjnym. */
    var pending = parent.querySelectorAll('[data-section-id=""]');
    for (var w = 0; w < pending.length; w++) {
      var wrap2 = pending[w].closest('[id^="shopify-section-"]');
      if (wrap2) pending[w].setAttribute('data-section-id', wrap2.id.replace('shopify-section-', ''));
    }
    runScripts(parent);
    if (focusSel) {
      var f = document.querySelector(focusSel);
      if (f && typeof f.focus === 'function') { try { f.focus({ preventScroll: true }); } catch (e) {} }
    }
    document.dispatchEvent(new CustomEvent('cclazy:materialized', { detail: { part: part } }));
  }

  function load(entry) {
    if (entry.state === 'done') return Promise.resolve();
    if (entry.promise) return entry.promise;
    entry.state = 'loading';
    entry.promise = fetchSection(entry.id, entry.base, entry.cache)
      .then(function (html) {
        entry.state = 'done';
        materialize(entry.slot, html);
        teardown(entry);
      })
      .catch(function () {
        /* Sieć padła — placeholder zostaje, lustro `<noscript>` nie jest
           renderowane przy włączonym JS, więc odsłaniamy zapasowy odnośnik. */
        entry.state = 'error';
        entry.promise = null;
        entry.slot.setAttribute('data-cclazy-state', 'error');
      });
    return entry.promise;
  }

  /* Cele liczymy RAZ na wpis. Liczenie ich przy każdym `pointerover` byłoby
     kilkoma `querySelectorAll` na zdarzenie — dokładnie ten koszt na wątku
     głównym, który ta runda ma usuwać. */
  function targetsOf(entry) {
    if (entry._targets) return entry._targets;
    var t = [entry.slot];
    var owner = entry.slot.getAttribute('data-cclazy-owner');
    if (!owner) {
      /* Automatyczne wykrycie właściciela: najbliższy przodek z `id`, na który
         wskazuje jakiekolwiek `aria-controls`. Dzięki temu placeholder wewnątrz
         dowolnej szuflady/modala motywu (np. szuflada filtrów) sam dostaje
         przycisk otwierający jako wyzwalacz — bez parametrów w Liquidzie. */
      var p = entry.slot.parentElement;
      while (p && p !== document.body) {
        if (p.id && document.querySelector('[aria-controls="' + p.id + '"]')) { owner = p.id; break; }
        p = p.parentElement;
      }
    }
    if (owner) {
      var o = document.getElementById(owner);
      if (o) t.push(o);
      var ctrl = document.querySelectorAll('[aria-controls="' + owner + '"]');
      for (var i = 0; i < ctrl.length; i++) t.push(ctrl[i]);
    }
    var sel = entry.slot.getAttribute('data-cclazy-trigger');
    if (sel) {
      var extra = document.querySelectorAll(sel);
      for (var k = 0; k < extra.length; k++) t.push(extra[k]);
    }
    entry._targets = t;
    return t;
  }

  function hits(entry, node) {
    if (!node) return false;
    var t = targetsOf(entry);
    for (var i = 0; i < t.length; i++) {
      if (t[i] === node || (t[i].contains && t[i].contains(node))) return true;
    }
    return false;
  }

  function el(node) { while (node && node.nodeType !== 1) node = node.parentNode; return node; }

  function onIntent(ev) {
    var node = el(ev.target);
    if (!node) return;
    for (var i = 0; i < slots.length; i++) {
      var e = slots[i];
      if (e.state === 'done' || !e.intent) continue;
      if (hits(e, node)) load(e);
    }
  }

  /* Kliknięcie przed materializacją — wstrzymaj, dociągnij, odtwórz. */
  function onClickCapture(ev) {
    var node = el(ev.target);
    if (!node) return;
    for (var i = 0; i < slots.length; i++) {
      var e = slots[i];
      /* Przechwytujemy TYLKO kliknięcia w wyzwalacz elementu, którego brak
         wywróciłby handler motywu (`aria-controls` -> `getElementById`).
         Panele menu otwiera hover/`<summary>`, a `pointerdown` zawsze wyprzedza
         `click` — nie ma powodu, żeby wstrzymywać zwykłą nawigację po linku. */
      if (e.state === 'done' || !e.intent || !e.clickGuard) continue;
      if (!hits(e, node)) continue;
      if (e.replaying) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      (function (entry, target) {
        load(entry).then(function () {
          entry.replaying = true;
          try {
            target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          } finally {
            setTimeout(function () { entry.replaying = false; }, 0);
          }
        });
      })(e, node.closest('[aria-controls],a,button') || node);
      return;
    }
  }

  var io = null;
  function observeView(entry) {
    if (!('IntersectionObserver' in window)) { load(entry); return; }
    if (!io) {
      io = new IntersectionObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) {
          if (!recs[i].isIntersecting) continue;
          var e = recs[i].target.__ccEntry;
          io.unobserve(recs[i].target);
          if (e) load(e);
        }
      }, { rootMargin: '800px 0px' });
    }
    entry.slot.__ccEntry = entry;
    io.observe(entry.slot);
  }

  function teardown(entry) {
    if (entry.eventName && entry.eventHandler) {
      document.removeEventListener(entry.eventName, entry.eventHandler);
      entry.eventHandler = null;
    }
    if (io && entry.slot && entry.slot.isConnected) { try { io.unobserve(entry.slot); } catch (e) {} }
  }

  function register(slot) {
    if (slot.__ccRegistered) return;
    slot.__ccRegistered = true;
    var on = (slot.getAttribute('data-cclazy-on') || 'intent').split(',').map(function (s) { return s.trim(); });
    var base = slot.getAttribute('data-cclazy-url') === 'here'
      ? (location.pathname + location.search)
      : ROOT;
    var entry = {
      slot: slot,
      id: slot.getAttribute('data-cclazy-section'),
      base: base,
      cache: slot.getAttribute('data-cclazy-cache') !== 'no',
      intent: on.indexOf('intent') > -1,
      clickGuard: !!slot.getAttribute('data-cclazy-owner'),
      state: 'idle',
      promise: null
    };
    if (!entry.id) return;
    slots.push(entry);
    if (on.indexOf('view') > -1) observeView(entry);
    var evName = slot.getAttribute('data-cclazy-event');
    if (on.indexOf('event') > -1 && evName) {
      entry.eventName = evName;
      entry.eventHandler = function () { load(entry); };
      document.addEventListener(evName, entry.eventHandler);
    }
    if (on.indexOf('now') > -1) load(entry);
  }

  function scan() {
    var list = document.querySelectorAll('[data-cclazy-slot]');
    for (var i = 0; i < list.length; i++) register(list[i]);
    slots = slots.filter(function (e) { return e.state === 'done' || (e.slot && e.slot.isConnected); });
  }

  document.addEventListener('pointerenter', onIntent, true);
  document.addEventListener('pointerover', onIntent, true);
  document.addEventListener('pointerdown', onIntent, true);
  document.addEventListener('focusin', onIntent, true);
  document.addEventListener('keydown', onIntent, true);
  document.addEventListener('click', onClickCapture, true);

  /* Sekcje wstrzyknięte później (Section Rendering po dodaniu do koszyka,
     przefiltrowana siatka) mogą przynieść nowe placeholdery. */
  function watch() {
    if (!window.MutationObserver || !document.body) return;
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; scan(); }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() { scan(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.ccLazySections = {
    load: function (part) {
      for (var i = 0; i < slots.length; i++) {
        if (slots[i].slot && slots[i].slot.getAttribute('data-cclazy-part') === part) return load(slots[i]);
      }
      return Promise.resolve();
    },
    state: function () { return slots.map(function (e) { return { part: e.slot && e.slot.getAttribute('data-cclazy-part'), id: e.id, state: e.state }; }); }
  };
})();
